import {LobbyImage} from '@colonist/types'
import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'
import {createDivIn, createParagraphIn, setElementOnClick} from '../../../../../shared/scripts/ui_utils/DomUtils'
import {getLobbyImagePath} from '../../../../../shared/scripts/ui_utils/Utils'

export class UIDConsoleLog {
    private isLogging: boolean = false
    private overrodeConsoleLog: boolean = false

    private container: HTMLDivElement
    private viewButton: HTMLDivElement

    private isHidden: boolean = false

    constructor() {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return
        if(!UIUtilsEjsVariables.showConsoleLogUI) return

        this.init()
    }

    init() {
        this.container = createDivIn(document.body, 'console-log')
        if(UIUtilsEjsVariables.isUserOnMobile) this.container.classList.add('console-log-mobile')

        this.viewButton = createDivIn(this.container, 'view-button')

        const buttonImg = document.createElement('IMG') as HTMLImageElement
        buttonImg.src = getLobbyImagePath(LobbyImage.XMark)
        this.viewButton.appendChild(buttonImg)

        setElementOnClick(this.viewButton, () => {
            if(this.isHidden) {
                this.container.classList.remove('hide-console')
                buttonImg.src = getLobbyImagePath(LobbyImage.XMark)
                this.isHidden = false
            } else {
                this.container.classList.add('hide-console')
                buttonImg.src = getLobbyImagePath(LobbyImage.Plus)
                this.isHidden = true
            }
        })

        this.overrideConsoleLog()
    }

    private log(message: string) {
        if(!UIUtilsEjsVariables.showConsoleLogUI) return
        const logDiv = createDivIn(this.container, 'log-section')
        createParagraphIn(logDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: message}}, 'log')
    }

    /* eslint-disable no-console*/
    private overrideConsoleLog() {
        if(this.overrodeConsoleLog) return

        const originalConsoleLog = console.log

        console.log = (...args: any[]) => {
            originalConsoleLog(...args.map((arg) => (typeof arg === 'object' ? JSON.stringify(arg, null, 2) : arg)))
            if(!this.isLogging) {
                this.isLogging = true
                this.log(args.map((arg) => (typeof arg === 'object' ? JSON.stringify(arg, null, 2) : arg)).join(' '))
                this.isLogging = false
            }
        }

        this.overrodeConsoleLog = true
    }
    /* eslint-disable */
}
